import { render, staticRenderFns } from "./PromoteurPresentation.vue?vue&type=template&id=6cf1809b&"
import script from "./PromoteurPresentation.vue?vue&type=script&lang=js&"
export * from "./PromoteurPresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports